export default class UI {
  Factory;
  constructor(sc) {
    this.Factory = new Factory(sc);
  }
}

class Factory {
  constructor(sc) {
    this.scene = sc;
  }
  clickableButton(ImgKey, X_proportion, Y_proportion, onClickEvent) {
    const button = this.scene.add.image(1920 * X_proportion, 1080 * Y_proportion, ImgKey).setInteractive({ cursor: "pointer" });
    button.on(
      "pointerup",
      () => {
        onClickEvent();
      },
      this
    );
    return button;
  }
}
